<template>
    <div>
        <v-card class="d-flex flex-column justify-space-between" style="position: relative" @click="$emit('showScreenshot')">
            <div class="d-flex align-start pa-1">
                <v-btn small text color="primary" @click.stop="!clickThrough ? $emit('gotoAppStats', screenshot.match) : gotoAppStats(screenshot.match)">
                    <app-icon :match="screenshot.match" left small/>
                    {{screenshot.match}}
                </v-btn>

                <div class="caption flex-grow-1 text-truncate text-end grey--text">
                    {{viewDate}}
                </div>
            </div>

            <div style="height: 120px">
                <div class="d-flex align-center justify-center pb-2" v-if="loading" style="position: absolute; top: 0; left: 0; height: 100%; width: 100%">
                    <v-progress-circular
                            :size="30"
                            width="2"
                            color="grey darken-2"
                            indeterminate
                    ></v-progress-circular>
                </div>
                <div style="background: #1e1e1e" class="text-center overline error--text" v-else-if="imageError">
                    Image Error
                </div>
                <div v-else class="backImage d-flex align-center justify-center fill-height">
<!--                    :src="`data:image/jpeg;base64,${screenshot.image}`"-->
                    <img
                            :src="screenshot.image"
                            style="max-width: 100%; max-height: 120px"
                            alt="Screenshot"
                    >
                </div>
            </div>


            <div class="d-flex align-center flex-wrap justify-space-around pa-1">
                <v-btn x-small text color="primary" @click.stop="!clickThrough ? $emit('gotoTeam', screenshot.teamId) : gotoTeam(screenshot.teamId)">
                    <v-icon left small>mdi-account-group</v-icon>
                    {{screenshot.teamName}}
                </v-btn>
                <v-btn x-small text color="primary" @click.stop="!clickThrough ? $emit('gotoEmployee', screenshot.employeeId) : gotoEmployee(screenshot.employeeId)">
                    <v-icon left small>mdi-account</v-icon>
                    {{screenshot.employeeName}}
                </v-btn>
                <v-btn x-small text color="primary" @click.stop="!clickThrough ? $emit('gotoDeviceSettings', screenshot.deviceId) : gotoDeviceSettings(screenshot.deviceId)">
                    <v-icon left small>mdi-cellphone-link</v-icon>
                    {{screenshot.deviceName}}
                </v-btn>
            </div>
        </v-card>
    </div>

</template>

<script>
import {dateFormats, durationDisplay, isValidUrl} from "@/core/codeFunctions";
import {format} from "date-fns";
import {mapActions} from "vuex";
import AppIcon from "@/components/Shared/AppIcon";
import axios from "axios";

export default {
    components: {AppIcon},
    props: {
        screenshot: Object,
        clickThrough: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            durationDisplay: durationDisplay,
            loading: false,
            imageError: false,
            isValidUrl,
        }
    },
    mounted() {
        if (!this.screenshot.image) {
            this.loadImage()
        }
    },
    methods: {
        ...mapActions(['gotoAppStats', 'gotoEmployee', 'gotoTeam', 'gotoDeviceSettings']),
        async loadImage() {
            try {
                this.loading = true;
                const {data: imageData} = await this.$newReqDownloadFile(
                        'POST',
                        'screenshots/loadImage',
                        {_id: this.screenshot._id},
                        'image',
                        true,
                        false,
                        null,
                        true
                )

                if (imageData.type === "text/html") {
                    const fetchUrl = await imageData.text()
                    const {data: imageBlob} = await axios.get(fetchUrl, {responseType: 'blob'})
                    const blob = imageBlob.slice(0, imageBlob.size, "image/jpeg")
                    this.screenshot.image = URL.createObjectURL(blob);
                } else {
                    this.screenshot.image = URL.createObjectURL(imageData);
                }
            } catch (e) {
                console.log(e)
                this.imageError = true
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        viewDate() {
            return format(this.screenshot.start, dateFormats.medDate)
        },
    },
}
</script>

<style scoped>
    .backImage{
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
</style>